import { jsx as _jsx } from "react/jsx-runtime";
import { Suspense, startTransition, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import Loader from './components/layout/common/Loader';
import { persistor, store } from './store';
import App from './app';
import { Amplify } from 'aws-amplify';
import config from '@/utils/aws-exports';
import '@cloudscape-design/global-styles/index.css';
Amplify.configure({
    Auth: {
        Cognito: {
            userPoolId: config.USER_POOL_ID,
            userPoolClientId: config.USER_POOL_APP_CLIENT_ID,
            // userPoolEndpoint: `https://${config.DOMAIN}`,
            loginWith: {
                oauth: {
                    domain: "".concat(config.DOMAIN),
                    scopes: ['openid', 'aws.cognito.signin.user.admin'],
                    responseType: 'code',
                    redirectSignIn: [globalThis.location.origin],
                    redirectSignOut: [globalThis.location.origin],
                },
            },
        },
    },
});
var Root = function () {
    useEffect(function () {
        startTransition(function () {
            persistor.persist(); // Trigger the rehydration process with startTransition
        });
    }, []);
    return (_jsx(Provider, { store: store, children: _jsx(BrowserRouter, { basename: "/", children: _jsx(Suspense, { fallback: _jsx(Loader, {}), children: _jsx(App, {}) }) }) }));
};
var container = document.getElementById('root');
var root = createRoot(container);
startTransition(function () {
    root.render(_jsx(Root, {}));
});
export default Root;
